var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Header = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-family: 'Barlow';\n  font-weight: 600;\n  font-size: 1.5rem;\n"], ["\n  text-transform: uppercase;\n  font-family: 'Barlow';\n  font-weight: 600;\n  font-size: 1.5rem;\n"])));
var templateObject_1;
//# sourceMappingURL=Header.js.map